import { apiGet } from './client'
import { collectPages } from './collections'
import type { Envelope, FavoriteFolderSummary, FavoriteSummary } from './types'

export const loadFavoriteFolders = () => collectPages(cursor => apiGet<Envelope<FavoriteFolderSummary[]>>('/favorite-folders', { limit: 100, cursor }))
export const loadFavorites = () => collectPages(cursor => apiGet<Envelope<FavoriteSummary[]>>('/favorites', { limit: 100, cursor }))
